// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".news-item-details[data-v-4696cc20]{padding:0 16px 16px;overflow-x:hidden;overflow-y:auto}.title[data-v-4696cc20]{font-size:18px;margin-bottom:8px}.date[data-v-4696cc20]{font-size:14px;opacity:.5}.content[data-v-4696cc20],.media[data-v-4696cc20]{margin-top:16px}.content[data-v-4696cc20] img,.content[data-v-4696cc20] video,.media-content[data-v-4696cc20]{max-width:100%;max-height:300px}", ""]);
// Exports
module.exports = exports;
